import React, { useState,useEffect,useCallback } from 'react';
import { App, Modal, Pagination, Button,Table } from 'antd';
import { useNavigate,useLocation } from 'react-router-dom';
import styles from './PostordersList.module.scss';
import EmergencyOrderEditDialog from '@/components/EmergencyOrderEditDialog';
import EmergencyServicesCarpoolProgressDetail from '../EmergencyServicesCarpoolProgressDetail';
import { saveOrderDelete, saveOrderStatus, getEmergencyServiceById } from '@/api/order';
import { getBiddingList,selectWinner } from '@/api/emergencyServiceApi';
import { emergencyServiceOrderStatusOptionsMapper,serviceCarpoolOrderStatus } from '@/utils/constants';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@/store/hooks';
import OrderDialog, {
  OrderDialogMode,
} from "@/components/OrderDialog/OrderDialog";
import dayjs from 'dayjs';
// 紧急服务用户类型
interface EmergencyServiceUser {
  user_id: string;
  merchant_id: string;
  first_name: string;
  last_name: string;
  nick_name: string;
  username: string;
  email: string;
  phone: string | null;
  photo: string | null;
  gender: number;
  birthday: string | null;
  level: number;
  is_delete: boolean;
  create_time: string;
  update_time: string;
}

// 紧急服务图片类型
interface EmergencyServiceImage {
  file_id: string;
  product_id: string | null;
  product_media_id: string | null;
  product_media_type: string;
  product_media_file_url: string;
  product_media_video_cover_id: string | null;
}

// 紧急服务数据类型
interface EmergencyServiceData {
  emergency_service_id: string;
  user: EmergencyServiceUser;
  service_category: any[];
  urgency_level: number;
  problem_description: string;
  budget: string;
  budget_price: string;
  latitude: string;
  longitude: string;
  city_state: string;
  address: string;
  phone: string;
  appointment_time: string;
  images: EmergencyServiceImage[];
  status: number;
  create_time: string;
  distance: number;
}

// 竞价数据类型
interface BiddingData {
  id: string;
  townloopId: string;
  pricingMethod: string;
  price: string;
  creationTime: string;
  distance: string;
}

interface YourTownloopOrdersListProps {
  orders: EmergencyServiceData[];
}

const YourTownloopOrdersList: React.FC<YourTownloopOrdersListProps> = ({ orders }) => {
  const { message } = App.useApp();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  // 发布顺风车帖子表单
  const [publishForm, setPublishForm] = useState<any>({
    phone: "",
    address: "",
    urgency_level: "",
    images: "",
    budget: "",
    longitude: "",
    latitude: "",
    emergency_service_id: ""
  });
  // 列表数据
  const [dataSource, setDataSource] = useState<any[]>([]);
  // 单选选中的行key
  const [selectedRowKey, setSelectedRowKey] = useState<string | null>(null);
  //发布人拼车订单进度弹窗状态控制
  const [showProgressModal, setShowProgressModal] = useState(false);
  // 选中的行数据
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [type, setType] = useState<any>('delivery');//ride是顺风车 delivery是代驾
  const [isPoster, setIsPoster] = useState(true);//true是订单发布者 false是司机接单人
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [mode, setMode] =
    React.useState<OrderDialogMode>("bidding");
  const [currentOrder, setCurrentOrder] =
    React.useState<any | null>(null);
  const [odersItem, setOdersItem] = useState<any>(null);
    //关闭发布人拼车订单进度弹窗
  const CarpoolProgressDetailClose = (id: string, action: string) => {
    //刷新当前页面
    // getId && getId(id, action);
    //关闭当前弹窗
    setShowProgressModal(false);
  }
  const columns = [
    {
      title: 'Select',
      key: 'select',
      align: 'center' as const,
      width: 80,
      render: (text: any, record: any) => (
        <input
          type="radio"
          name="tableRowSelect"
          checked={selectedRowKey === record.bidding_id}
          onClick={() => handleRowSelect(record)}
          style={{ cursor: 'pointer' }}
        />
      ),
    },
    {
      title: 'name',
      dataIndex: 'Name',
      key: 'Name',
      align: 'center' as const,

    },
    {
      title: 'price',
      dataIndex: 'bidding',
      key: 'bidding',
      align: 'center' as const,
    },
    {
      title: 'Distance',
      dataIndex: 'distance',
      key: 'distance',
      align: 'center' as const,
    },
    {
      title: 'Rating',
      dataIndex: 'Rating',
      key: 'Rating',
      align: 'center' as const,
      
    },
    {
      title: 'license type',
      dataIndex: 'LicenseType',
      key: 'LicenseType',
      align: 'center' as const,
    },
    {
      title: 'Email',
      dataIndex: 'Email',
      key: 'Email',
      align: 'center' as const,
    },
    {
      title: 'phone',
      dataIndex: 'phone',
      key: 'phone',
      align: 'center' as const,
    },
  ];
  // 处理行选择
  const handleRowSelect = useCallback((record: any) => {
    if (selectedRowKey === record.bidding_id) {
      // 点击已选中的行，取消选择
      setSelectedRowKey(null);
      setSelectedRowData(null);
      message.info('Selection cleared');
    } else {
      // 选择新行
      setSelectedRowKey(record.bidding_id);
      setSelectedRowData(record);
      message.success(`Selected: ${record.Name}`);
    }
    // console.log("record",record,selectedRowKey)
  }, [selectedRowKey]);
  // 筛选按钮排序状态
  const [priceSort, setPriceSort] = useState<'asc' | 'desc' | null>(null);
  const [distanceSort, setDistanceSort] = useState<'asc' | 'desc' | null>(null);
  const [ratingSort, setRatingSort] = useState<'asc' | 'desc' | null>(null);
  // 价格排序函数 - 正序
  const handlePriceAsc = () => {
    setPriceSort('asc');
    setDistanceSort(null);
    setRatingSort(null)
    const sortedData = [...dataSource].sort((a, b) => a.price - b.price);
    setDataSource(sortedData);
    message.success('Price sorted low to high');
  };

  // 价格排序函数 - 倒序
  const handlePriceDesc = () => {
    setPriceSort('desc');
    setDistanceSort(null);
    setRatingSort(null)
    const sortedData = [...dataSource].sort((a, b) => b.price - a.price);
    setDataSource(sortedData);
    message.success('Price sorted high to low');
  };

  // 距离排序函数 - 正序
  const handleDistanceAsc = () => {
    setDistanceSort('asc');
    setPriceSort(null);
    setRatingSort(null)
    const sortedData = [...dataSource].sort((a, b) => {
      const numA = parseFloat(a.Distance);
      const numB = parseFloat(b.Distance);
      return numA - numB;
    });
    setDataSource(sortedData);
    message.success('Distance sorted near to far');
  };

  // 距离排序函数 - 倒序
  const handleDistanceDesc = () => {
    setDistanceSort('desc');
    setPriceSort(null);
    setRatingSort(null)
    
    const sortedData = [...dataSource].sort((a, b) => {
      const numA = parseFloat(a.Distance);
      const numB = parseFloat(b.Distance);
      return numB - numA;
    });
    setDataSource(sortedData);
    message.success('Distance sorted far to near');
  };
  // 评分排序函数 - 正序
  const handleRatingAsc = () => {
    setRatingSort('asc');
    setDistanceSort(null);
    setPriceSort(null);
    const sortedData = [...dataSource].sort((a, b) => a.Rating - b.Rating);
    setDataSource(sortedData);
    message.success('Price sorted low to high');
  };

  // 评分排序函数 - 倒序
  const handleRatingDesc = () => {
    setRatingSort('desc');
    setDistanceSort(null);
    setPriceSort(null);
    const sortedData = [...dataSource].sort((a, b) => b.Rating - a.Rating);
    setDataSource(sortedData);
    message.success('Price sorted high to low');
  };
    // 三角形按钮组件
  const TriangleButton = ({ 
    type,
    label,
    sortType,
    onAscClick,
    onDescClick
  }: {
    type: 'price' | 'distance' | 'Rating';
    label: string;
    sortType: 'asc' | 'desc' | null;
    onAscClick: () => void;
    onDescClick: () => void;
  }) => {
    // const isActive = (type === 'price' && priceSort) || (type === 'distance' && distanceSort);
    // const currentSort = type === 'price' ? priceSort : distanceSort;
     let currentSort:any = "price";
    if(type === 'price'){
      currentSort = priceSort
    }else if(type === 'distance'){
      currentSort = distanceSort
    }else{
      currentSort = ratingSort
    }
    
    return (
      <div className={`${styles['triangle-button-group']} ${type === 'distance' ? styles['distance'] : ''}`}>
        <span className={styles['button-label']}>{label}</span>
        <div className={styles['triangle-buttons']}>
          <button 
            className={`${styles['triangle-btn']} ${styles['triangle-up']} ${currentSort === 'asc' ? styles['active'] : ''}`}
            onClick={onAscClick}
            title="Sort ascending"
          >
            {/* 上三角形图标 */}
          </button>
          <button 
            className={`${styles['triangle-btn']} ${styles['triangle-down']} ${currentSort === 'desc' ? styles['active'] : ''}`}
            onClick={onDescClick}
            title="Sort descending"
          >
            {/* 下三角形图标 */}
          </button>
        </div>
      </div>
    );
  };
  //获取订单页列表
  const getBiddingListData = (emergency_service_id: string) => {
 
    const params: any = {emergency_service_id };
    console.log(emergency_service_id, 'emergency_service_id',params);
    let api = getBiddingList;

    // if(activeCategory === 'delivery'){
    //   api = getCarpoolDeliveryOrderList;
    // }
    api(params).then((res: any) => {
      console.log(res, 'getOrderPageListData');
      if (res.code === 200) {
        // 转换数据格式
        setDataSource(res.data.bidding_list);

      } else {
        message.error(res.message || 'Failed to get order list');
      }
    }).catch((error) => {
      console.error('Failed to get order list:', error);
      message.error('Failed to get order list');
    }).finally(() => {
      // setLoading(false);
    });
  }
  // 统一格式化服务分类，保证列表与弹窗一致
  const formatServiceCategory = (serviceCategory: any): string => {
    if (!serviceCategory) return '';
    // 后端可能返回字符串、数组（id 或对象）、或嵌套名称
    if (typeof serviceCategory === 'string') return serviceCategory;
    if (Array.isArray(serviceCategory)) {
      const names = serviceCategory.map((item: any) => {
        if (item == null) return '';
        if (typeof item === 'string' || typeof item === 'number') return String(item);
        // 对象时尝试常见字段
        return (
          item.product_category_name ||
          item.label ||
          item.name ||
          String(item.value ?? '')
        );
      }).filter((s: string) => s && s.trim() !== '');
      return names.join(' / ');
    }
    // 对象时尝试直接读取名称
    return (
      serviceCategory.product_category_name ||
      serviceCategory.label ||
      serviceCategory.name ||
      String(serviceCategory.value ?? '')
    );
  };
  const params = useLocation(); // 获取URL参数
  // 订单状态映射函数
  const getOrderStatusText = (status: number): string => {
    
    let orderStatusOptions = null;
    if(params.pathname === "/yourtownloop/serviceorders"){
      orderStatusOptions = serviceCarpoolOrderStatus()
    }else {
      orderStatusOptions = emergencyServiceOrderStatusOptionsMapper()
    }
    //2,3,4,5都是Ongoing状态
    if(status===2||status===5||status===3||status===4){
      status = 2
    }
    if(status===6){
      status = 4
    }
    if(status===7){
      status = 3
    }
    // console.log("params",params,orderStatusOptions,serviceCarpoolOrderStatus(),emergencyServiceOrderStatusOptionsMapper())
    const statusOption = orderStatusOptions.find(option => option.value === status);
    return statusOption?.label || 'Unknown Status';
  };
  
  // 竞价相关状态
  const [biddingModalVisible, setBiddingModalVisible] = useState(false);
  const [biddingData, setBiddingData] = useState<BiddingData[]>([]);
  const [biddingPagination, setBiddingPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });

  // 订单详情弹出框状态
  const [orderDetailsModalVisible, setOrderDetailsModalVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<EmergencyServiceData | null>(null);

  // 弹出框展开产品详情
  const OrderDetails = (order: EmergencyServiceData) => {
    setSelectedOrder(order);
    setOrderDetailsModalVisible(true);
  };
  const handleOrderCheckIn = (order: EmergencyServiceData) => {
    // 待接口联调
  };
  const latitude = useAppSelector((state) => state.user.latitude);
  const longitude = useAppSelector((state) => state.user.longitude);
const handleOrderNavigation = (order: EmergencyServiceData) => {
    console.log('order===', order,latitude);
    let api = getEmergencyServiceById;
    localStorage.setItem("emergency_service_info",JSON.stringify(order))
    let params: any = {
       emergency_service_id: order.emergency_service_id
    };
    // 根据ID获取订单详情
    api(params).then((res) => {
      console.log('res', res);
      if (res.code === 200) {
        const orderDetails = res.data;
        setPublishForm({
          phone: orderDetails?.phone,
          address: orderDetails?.address,
          urgency_level: orderDetails?.urgency_level,
          images: orderDetails?.images,
          budget: orderDetails?.budget,
          latitude,
          longitude,
          emergency_service_id: order.emergency_service_id
          
        });
        setShowProgressModal(true);

      } else {
        message.error(res.message || 'Failed to get order details');
      }
    })
  }
  const handleConfirm = () => {
    setDialogOpen(false);    
  };
  const handleAdjustClick = () => {
    console.log("biddingModalVisible",selectedRowKey,odersItem,biddingData)
    selectWinner({bidding_id:selectedRowKey,emergency_service_id:odersItem.emergency_service_id}).then((res: any) => {
      console.log(res, 'getOrderPageListData');
      if (res.code === 200) {
        // 转换数据格式
        setDataSource(res.data.bidding_list);
        setBiddingModalVisible(false)
      } else {
        message.error(res.message || 'Failed to get order list');
      }
    }).catch((error) => {
      console.error('Failed to get order list:', error);
      message.error('Failed to get order list');
    }).finally(() => {
      // setLoading(false);
    });
    setDialogOpen(true);
  };
  // 删除订单确认
  const handleDeleteOrder = (order: EmergencyServiceData) => {
    let content = params.pathname === "/yourtownloop/postorders"?t("YourTownloopOrdersList.OrderDeleteContent"):t("YourTownloopOrdersList.serviceOrdersDeleteContent")

    Modal.confirm({
      title: `${t("YourTownloopOrdersList.ConfirmDeleteOrder")}`,
      content: content,
      okText: `${t("YourTownloopOrdersList.Delete")}`,
      okType: 'danger',
      cancelText: `${t("YourTownloopOrdersList.Cancel")}`,
      onOk: async () => {
        try {
          const params = {
            is_delete: true,
            order_id: order.emergency_service_id
          };
          
          const res = await saveOrderDelete(params);
          if (res.code === 200) {
            message.success('Order deleted successfully');
    
          } else {
            message.error(res.message || 'Delete failed');
          }
        } catch (error) {
          console.error('Delete order failed:', error);
          message.error('Delete failed, please try again');
        }
      },
    });
  };

  // 取消订单确认
  const handleOrderCancelled = (order: EmergencyServiceData) => {
    let content = params.pathname === "/yourtownloop/postorders"?t("YourTownloopOrdersList.OrderDeleteContent"):t("YourTownloopOrdersList.serviceOrdersDeleteContent")
    Modal.confirm({
      title: `${t("YourTownloopOrdersList.ConfirmDeleteOrder")}`,
      content: content,
      okText: `${t("YourTownloopOrdersList.Delete")}`,
      okType: 'danger',
      cancelText: `${t("YourTownloopOrdersList.Cancel")}`,
      onOk: async () => {
        try {
          const params = {
            order_id: order.emergency_service_id,
            order_status: 2
          };
          
          const res = await saveOrderStatus(params);
          if (res.code === 200) {
            message.success(t('YourTownloopOrdersList.OrderCancelledSuccessfully'));
            // 用于刷新列表
            
          } else {
            message.error(res.message || (t('YourTownloopOrdersList.Failed')));
          }
        } catch (error) {
          console.error('Cancel order failed:', error);
          message.error(t('YourTownloopOrdersList.OrderDeletedFailed'));
        }
      }
    });
  };

  // 处理竞价按钮点击
  const handleBiddingClick = (order: any) => {
    getBiddingListData(order.emergency_service_id)
    // console.log(order)
    setOdersItem(order);
    setBiddingModalVisible(true);
  };

  // 竞价分页变化
  const handleBiddingPaginationChange = (page: number, pageSize: number) => {
    setBiddingPagination({
      ...biddingPagination,
      current: page,
      pageSize
    });
  };

  // 处理支付按钮点击
  const handlePayClick = (biddingItem: BiddingData) => {
    message.success(`Processing payment for ${biddingItem.townloopId}`);
    // 这里可以添加实际的支付逻辑
  };
  const handlePayItemClick = (orderItem: EmergencyServiceData) => {
      console.log(orderItem)
      localStorage.setItem("emergency_service_info",JSON.stringify(orderItem))
      const productsToOrder = [{
        product_id: "PROD-3b56545e11561764313798029",
        type: 1,  // 1预付款  2尾款
        product_sku_id: "SN-763c990a-9fec-4fc0-847e-9b909d8435df",
    }];
    const encodedData = btoa(JSON.stringify(productsToOrder));
    navigate(`/emergency_service_ordering?products_to_order=${encodedData}`);
  };
  const [editOpen, setEditOpen] = useState(false);
  // 紧急程度
  const UrgencyLevel = useAppSelector((state) => state.common.UrgencyLevel);
  const getUrgencyLevelName = useCallback((urgency_level:number)=>{
    return UrgencyLevel.find((item:any)=>item.value === urgency_level)?.label;
  },[orders])   
  // useEffect(() => {
  //     getOrderPageListData(1, 10);
  // }, []);
  
  return (
    <>
      <div className={styles['orders-list-wrapper']}>
      {/* 表头 */}
      <div className={styles['orders-list-header']}>
        <div className={styles['header-info']}>Order Information</div>
        <div className={styles['header-right']}>
          <div className={styles['header-amount']}>Urgency Level</div>
          <div className={styles['header-paid']}>Starting Bid</div>
          <div className={styles['header-paid']}>Winning Bid</div>
          <div className={styles['header-handle']}>Order Handling</div>
        </div>

      </div>
      {orders.map((order:any) => (
        <div className={styles['order-block']} key={order.emergency_service_id}>
          {/* 订单头部 */}
          <div className={styles['order-header']}>
            <div className={styles['order-header-left']}>
              <span className={styles['order-date']}>
                {new Date(order.create_time).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit'
                }).replace(/(\d+)\/(\d+)\/(\d+)/, '$3/$1/$2')}
              </span>
              <span className={styles['order-number']}>Order Number:{order.emergency_service_id}</span>
              <span 
                className={styles['order-details']}
                onClick={() => OrderDetails(order)}
              >Order Details &gt;</span>
            </div>
            <div className={styles['order-header-right']}>
              <span className={styles['order-status']}>{getOrderStatusText(order.status)}</span>
            </div>
          </div>
          {/* 商品信息区块 */}
          <div className={styles['order-body']}>
            <div className={styles['order-product-info']}>
              <img 
                className={styles['product-img']} 
                // 暂时不跳转
                // onClick={() => navigate(`/ProductDetail/${order.emergency_service_id}`)} 
                src={order.images?.[0]?.product_media_file_url || ''} 
                alt={order.problem_description} 
              />
              <div className={styles['product-detail']}>
                <div className={styles['product-title']} >
                  {formatServiceCategory(order.service_category)}
                </div>
                <div className={styles['product-specs']}>
                  <div className={styles['spec-item']}>
                    <span className={styles['spec-label']}>Address: </span>
                    <span className={styles['spec-value']} title={order.address}>{order.address}</span>
                  </div>
                  <div className={styles['spec-item']}>
                    <span className={styles['spec-label']}>Appointment Time: </span>
                    <span className={styles['spec-value']} title={order.appointment_time}>{order.appointment_time}</span>
                  </div>

                  <div className={styles['spec-item']}>
                    <span className={styles['spec-label']}>Problem Description: </span>
                    <span className={styles['spec-value']} title={order.problem_description}>{order.problem_description}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles['order-product-action']}>            
              <div className={styles['order-budget-info']}>
                <div className={styles['product-price']}>{getUrgencyLevelName(order.urgency_level)}</div>
                  
              </div>
              <div className={styles['order-paid-info']}>
                <div className={styles['paid-label-box']}>
                  <div className={styles['paid-amount']}>${order.budget}</div>
                </div>
              </div>
              <div className={styles['order-paid-info']}>
                <div className={styles['paid-label-box']}>
                  <div className={styles['paid-amount']}>${order.budget}</div>
                </div>
              </div>
              <div className={styles['order-actions']}>
                {params.pathname === "/yourtownloop/postorders"?
                  <>
                    { getOrderStatusText(order.status)==="Draft" && <button 
                      className={styles['bidding-btn']}
                      onClick={() => handlePayItemClick(order)}
                    >
                      pay
                    </button>
                    }
                    { getOrderStatusText(order.status)==="Pending" && <button 
                      className={styles['bidding-btn']}
                      onClick={() => handleBiddingClick(order)}
                    >
                      Award
                    </button>
                    }
                    { (order.status=="2" || order.status=="3"|| order.status=="4"|| order.status=="5") && <button 
                      className={styles['bidding-btn']}
                      onClick={() => handleOrderNavigation(order)}
                    >
                      progress
                    </button>
                    }
                    { getOrderStatusText(order.status)==="Processed" && <button 
                      className={styles['bidding-btn']}
                      onClick={() => handleBiddingClick(order)}
                    >
                      Rating
                    </button>
                    }
                    { (getOrderStatusText(order.status)==="Draft"|| getOrderStatusText(order.status)==="Pending") && <button 
                      className={styles['repeat-cart']}
                      onClick={() => setEditOpen(true)}
                    >
                      Edit
                    </button> 
                    }
                    { (getOrderStatusText(order.status)==="canceled"|| getOrderStatusText(order.status)==="Processed" || getOrderStatusText(order.status)==="Draft") && <button 
                      className={styles['repeat-cart']}
                      onClick={() => handleDeleteOrder(order)}
                    >
                      Delete
                    </button> }
                    { (getOrderStatusText(order.status)==="Pending"|| getOrderStatusText(order.status)==="Ongoing") && <button 
                    className={styles['repeat-cart']}
                    onClick={() => handleOrderCancelled(order)}
                  >
                    Cancel
                  </button> }
                  </>
                  :<>
                    { getOrderStatusText(order.status)==="Pending" && <button 
                      className={styles['bidding-btn']}
                      onClick={() => handleBiddingClick(order)}
                    >
                      AdjustBid
                    </button>
                    }
                    { getOrderStatusText(order.status)==="Pending" && <button 
                      className={styles['repeat-cart']}
                      onClick={() => handleOrderCancelled(order)} >
                      Cancel
                    </button> }
                    { getOrderStatusText(order.status)==="Ongoing" && <button 
                      className={styles['bidding-btn']}
                      onClick={() => handleOrderNavigation(order)}
                    >
                      Navigate
                    </button>
                    }  
                    { getOrderStatusText(order.status)==="Ongoing" && <button 
                      className={styles['repeat-cart']}
                      onClick={() => handleOrderCheckIn(order)} >
                      Check-In
                    </button> } 
                    { (getOrderStatusText(order.status)==="canceled"||getOrderStatusText(order.status)==="Processed"||getOrderStatusText(order.status)==="lost") && <button 
                      className={styles['repeat-cart']}
                      onClick={() => handleOrderCancelled(order)} >
                      delete
                    </button> }                  
                  </>
                  }

              </div>
            </div>
          </div>
        </div>
      ))}
      </div>

      {/* 订单详情弹出框 */}
      <Modal
        title={
          <div style={{
            fontWeight: 'bold',
            fontSize: '24px',
            color: '#0D323E',
            lineHeight: '34px'
          }}>
            Order Details
          </div>
        }
        open={orderDetailsModalVisible}
        onCancel={() => setOrderDetailsModalVisible(false)}
        footer={null}
        width={800}
        className={styles['order-details-modal']}
      >
        {selectedOrder && (
          <div className={styles['order-details-content']}>
            {/* 位置和距离信息 */}
            <div className={styles['location-section']}>
              <div className={styles['location-left']}>
              <img 
                className={styles['product-img']} 
                // 暂时不跳转
                // onClick={() => navigate(`/ProductDetail/${selectedOrder.emergency_service_id}`)} 
                src={selectedOrder.images?.[0]?.product_media_file_url || ''} 
                alt={selectedOrder.problem_description} 
              />
              </div>
              <div className={styles['location-right']}>
                <div className={styles['location-item']}>
                  {formatServiceCategory(selectedOrder.service_category)}
                </div>
                <div className={styles['distance-item']}>
                <span className={styles['distanceIcon']} />
                2.5 Miles From You
                </div>
                <div className={styles['location-description']}>
                  <span>Problem Description:</span>
                   <span className={styles['location-description-value']}>{selectedOrder.problem_description}</span>
                </div>
              </div>
            </div>

            {/* 订单信息 */}
            <div className={styles['order-info-section']}>
              <div className={styles['info-row']}>
                <span className={styles['info-label']}>Phone:</span>
                <span className={styles['info-value']}>{selectedOrder.phone}</span>
              </div>
              <div className={styles['info-row']}>
                <span className={styles['info-label']}>Address:</span>
                <span className={styles['info-value']}>{selectedOrder.address}</span>
              </div>
              <div className={styles['info-row']}>
                <span className={styles['info-label']}>Order Number:</span>
                <span className={styles['info-value']}>{selectedOrder.emergency_service_id}</span>
              </div>
              <div className={styles['info-row']}>
                <span className={styles['info-label']}>Creation Time:</span>
                <span className={styles['info-value']}>{selectedOrder.create_time}</span>
              </div>

              <div className={styles['info-row']}>
                <span className={styles['info-label']}>Problem Description:</span>
                <span className={styles['info-value']}>{selectedOrder.problem_description}</span>
              </div>
              <div className={styles['info-row']}>
                <span className={styles['info-label']}>Budget:</span>
                <span className={styles['info-value']}>${selectedOrder.budget}</span>
              </div>

            </div>
          </div>
        )}
      </Modal>

      {/* 竞价弹出框 */}
      <Modal
        title={
          <div style={{
            fontWeight: 'bold',
            fontSize: '24px',
            color: '#0D323E',
            lineHeight: '34px'
          }}>
            Order Confirmation
          </div>
        }
        open={biddingModalVisible}
        onCancel={() => setBiddingModalVisible(false)}
        footer={null}
        width={1000}
        className={styles['bidding-modal']}
      >
        <div className={styles['bidding-content']}>
          <div  className={styles['bidding-ad-just']} onClick={handleAdjustClick}>Adjust Bid</div>
          {/* 筛选按钮 */}
          <div className={styles['bidding-filters']}>
            <TriangleButton
              type="price"
              label="Price"
              sortType={priceSort}
              onAscClick={handlePriceAsc}
              onDescClick={handlePriceDesc}
            />
            
            {/* 距离排序按钮组 */}
            <TriangleButton
              type="distance"
              label="Distance"
              sortType={distanceSort}
              onAscClick={handleDistanceAsc}
              onDescClick={handleDistanceDesc}
            />
            <TriangleButton
              type="Rating"
              label="Rating"
              sortType={ratingSort}
              onAscClick={handleRatingAsc}
              onDescClick={handleRatingDesc}
            />
           
          </div>

          {/* 订单信息头部 */}
          <div className={styles['bidding-header']}>
           
            <div className={styles['bidding-title']}>
              <p className={styles['bidding-title1']}>Appliance Repair/Air Conditioning Repair</p>
              <p className={styles['bidding-title-text']}>Order Number: 14785236987463157245</p>
            </div>
            <div className={styles['bidding-total']}>
              Total {biddingData.length} Orders
            </div>
          </div>

          {/* 竞价列表表格 */}
          <div className={styles['bidding-table']}>
            <Table
              className={styles['engineer-table']}
              dataSource={dataSource}
              columns={columns}
              rowKey="id"
              pagination={false}
              bordered
            />
          </div>

          {/* 分页 */}
          <div className={styles['bidding-pagination']}>
            <Pagination
              current={biddingPagination.current}
              pageSize={biddingPagination.pageSize}
              total={biddingData.length}
              onChange={handleBiddingPaginationChange}
              showSizeChanger={false}
              showQuickJumper
              showTotal={(total, range) => `Total ${total} Products`}
            />
          </div>
        </div>
      </Modal>
      {/* 编辑弹出框 */}
      <EmergencyOrderEditDialog open={editOpen} onCancel={() => setEditOpen(false)} />
      {/* 进度弹出框 */}
      <Modal
        title={
          <div style={{
            fontWeight: 'bold',
            fontSize: '24px',
            color: '#0D323E',
            lineHeight: '34px'
          }}>
            {t('YourTownloopOrdersListCar.OrderProgress')}
          </div>
        }
        open={showProgressModal}
        onCancel={() => setShowProgressModal(false)}
        footer={null}
        width={1200}
        className={styles['progress-modal']}
      >

        <EmergencyServicesCarpoolProgressDetail orderItem={publishForm} type={type} getId={CarpoolProgressDetailClose} isPoster={isPoster} />

      </Modal>
      {currentOrder && (
        <OrderDialog
          open={dialogOpen}
          mode={mode}
          order={currentOrder}
          onCancel={() => setDialogOpen(false)}
          onConfirm={() => handleConfirm()}
        />
      )}
    </>
  );
};

export default YourTownloopOrdersList; 